import { render, staticRenderFns } from "./OrderHistoryTabOrders.vue?vue&type=template&id=08edd6d2&scoped=true&"
import script from "./OrderHistoryTabOrders.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryTabOrders.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryTabOrders.vue?vue&type=style&index=0&id=08edd6d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08edd6d2",
  null
  
)

export default component.exports